import { useState } from 'react';
import { useParams } from 'react-router';
import { PaginationState } from '@/components';
import { useGetPatientProvidersSummaries } from '../../../../hooks/patientsAPI';
import { ProvidersTable } from './ProvidersTable';

export const ProvidersSection = () => {
  const { patientId } = useParams<{ patientId: string }>();

  const [pagination, setPagination] = useState<PaginationState>({
    page: 0,
    pageSize: 10,
  });

  const { data, isLoading } = useGetPatientProvidersSummaries(
    patientId
      ? {
          patientId,
          pagination: {
            offset: pagination.page * pagination.pageSize,
            limit: pagination.pageSize,
          },
        }
      : undefined,
  );

  return (
    <ProvidersTable
      providers={data?.records ?? []}
      totalCount={data?.totalCount ?? 0}
      isLoading={isLoading}
      pagination={pagination}
      onPaginationChange={setPagination}
    />
  );
};
